<owc-footer #footerElement fix-bottom variant="global" class="footer">
    <div slot="bottom">
        <owc-typography #typographyElement [element]="'sub'" [variant]="'subtitle2'">
            {{ i18n.FOOTER }}
        </owc-typography>
    </div>
</owc-footer>